import { Box, Flex, Text, Image, Grid, GridItem, Tabs, TabList, Tab, TabPanels, TabPanel, } from "@chakra-ui/react";
import MyDiv from "./manualAttendance.style";
import EmployeeIcon from "../../../assets/images/TotalEmployeeIcon.svg";
import PresenceIcon from "../../../assets/images/PersenceIcon.svg";
import AbsenceIcon from "../../../assets/images/AbsenceIcon.svg";
import LateIcon from "../../../assets/images/LateIcon.svg";
import { ManualAttendanceList } from "../components";
import { useState } from "react";
import EmployeeWiseAttendance from "../components/EmployeeWiseAttendance/EmployeeWiseAttendance";


const ManualAttendance = () => {

  const [summary, setSummary] = useState<{ total: number, present: number, absent: number, halfDay: number }>({ total: 0, present: 0, absent: 0, halfDay: 0 });
  const cards = [
    { label: "Total Employees", icon: EmployeeIcon, count: summary.total },
    { label: "Present", icon: PresenceIcon, count: summary.present },
    { label: "Absent", icon: AbsenceIcon, count: summary.absent },
    { label: "Half day", icon: LateIcon, count: summary.halfDay },
  ];

  return (
    <MyDiv>
      <Box className="page_wrapper ">
        <Flex className="page_heading flex_header">
          <Text className="font-poppins text_3xl text_semibold">Manual Attendance Sheet</Text>
          <Flex gap={3}>
          </Flex>
        </Flex>
        <Grid className="grid_container grid_gap_sm">
          {cards.map((card, index) => (
            <GridItem key={index} colSpan={{ base: 12, sm: 6, md: 6, lg: 3 }} className="card_box">
              <Flex align="center" gap={3} mb={3}>
                <Image src={card.icon} className="card_icon" alt={card.label} />
                <Text className="card_label font-poppins text_md text_medium">{card.label}</Text>
              </Flex>
              <Text className="card_value font-poppins text_bold">{card.count}</Text>
            </GridItem>
          ))}
        </Grid>
      </Box>
      <Grid className="grid_container" mt={4}>
        <GridItem colSpan={12}>
          <Tabs mt={4} colorScheme="green">
            <TabList>
              <Tab className="font-poppins text_sm text_medium">Date Wise</Tab>
              <Tab className="font-poppins text_sm text_medium">Employee Wise</Tab>
            </TabList>
            <TabPanels>
              <TabPanel px={0}>
                <ManualAttendanceList summary={summary} setSummary={setSummary} />
              </TabPanel>
              <TabPanel px={0}>
                <EmployeeWiseAttendance />
              </TabPanel>
            </TabPanels>
          </Tabs>
        </GridItem>
        {/* <GridItem colSpan={12}>
          <ManualAttendanceList summary={summary} setSummary={setSummary} />
        </GridItem> */}
      </Grid>
    </MyDiv>
  );
};

export default ManualAttendance;
